import { ExperienceTimelineViewState } from './useExperienceTimelineViewState';
import { clampZoom } from './zoom';

// Pure view-state transitions, shared by the `useExperienceTimelineViewState`
// convenience hook and by `ExperienceTimeline` itself (which is a controlled
// component driven by `view`/`onViewChange`, so it needs these same
// transitions without depending on the hook).

export const zoomInView = (v: ExperienceTimelineViewState): ExperienceTimelineViewState => ({
  ...v,
  zoom: clampZoom(v.zoom + 1)
});

export const zoomOutView = (v: ExperienceTimelineViewState): ExperienceTimelineViewState => ({
  ...v,
  zoom: clampZoom(v.zoom - 1)
});

export const toggleHideLabelsView = (
  v: ExperienceTimelineViewState
): ExperienceTimelineViewState => ({ ...v, hideLabels: !v.hideLabels });

export const toggleLaneView = (
  v: ExperienceTimelineViewState,
  laneId: string
): ExperienceTimelineViewState => {
  const next = !v.collapsedLanes[laneId];
  const expandedClusters = { ...v.expandedClusters };
  if (next) {
    Object.keys(expandedClusters).forEach((key) => {
      if (key.startsWith(`${laneId}:`)) delete expandedClusters[key];
    });
  }
  return {
    ...v,
    collapsedLanes: { ...v.collapsedLanes, [laneId]: next },
    expandedClusters
  };
};

export const setLanesCollapsedView = (
  v: ExperienceTimelineViewState,
  laneIds: string[],
  collapsed: boolean
): ExperienceTimelineViewState => {
  const collapsedLanes = { ...v.collapsedLanes };
  laneIds.forEach((id) => {
    collapsedLanes[id] = collapsed;
  });
  return { ...v, collapsedLanes, expandedClusters: collapsed ? {} : v.expandedClusters };
};

export const expandClusterView = (
  v: ExperienceTimelineViewState,
  clusterKey: string
): ExperienceTimelineViewState => ({
  ...v,
  expandedClusters: { ...v.expandedClusters, [clusterKey]: true }
});

export const setHoveredIdView = (
  v: ExperienceTimelineViewState,
  id: string | null
): ExperienceTimelineViewState => (v.hoveredId === id ? v : { ...v, hoveredId: id });
